/**
 * Hide wishlist counter when count is 0
 */
document.addEventListener("DOMContentLoaded", function () {
	function toggleWishlistCounterVisibility() {
		const wishlistCounters = document.querySelectorAll('.js-wishlist-counter');

		wishlistCounters.forEach(function (counter) {
			const count = parseInt(counter.textContent) || 0;

			if (count === 0) {
				counter.style.display = 'none';
			} else {
				counter.style.display = 'flex';
			}
		});
	}

	// Run on page load
	toggleWishlistCounterVisibility();

	// Watch for changes in the counter elements
	const wishlistCounters = document.querySelectorAll('.js-wishlist-counter');
	wishlistCounters.forEach(function (counter) {
		const observer = new MutationObserver(function () {
			toggleWishlistCounterVisibility();
		});

		observer.observe(counter, {
			childList: true,
			characterData: true,
			subtree: true
		});
	});

	// Also watch for localStorage changes (for wishlist updates)
	window.addEventListener('storage', function (e) {
		if (e.key === 'wishlist') {
			toggleWishlistCounterVisibility();
		}
	});

	// Watch for custom wishlist events if they exist
	document.addEventListener('wishlist_updated', function () {
		setTimeout(toggleWishlistCounterVisibility, 100);
	});
});
